<template>
    <div class="dialog float fix flex wrap center" :class="{ 'show': show }">
        <div v-if="show" class="overlay" @click.prevent="data?.closeable ? $emit('onclose') : null"></div>
        <div class="popup"
            :class="[{ 'fullwidth': data?.fullwidth }, { 'halfwidth': data?.halfwidth }, { 'single': data?.single }, { 'thin': data?.thin }, { 'thin ultra': data?.thin && data?.ultra }, { 'internal': data?.internal }, { 'relative': data?.relative }]">
            <div v-if="data?.type !== 'form'" class="head">
                <div class="title">
                    <h1>{{ data?.title }}</h1>
                </div>
            </div>
            <div class="body">
                <KeepAlive v-if="data?.type === 'form'">
                    <Form :entity_type="data?.entity_type || ''" :entity_data="data?.data || {}" @onresult="onresult"
                        :internal="data?.internal">
                    </Form>
                </KeepAlive>
                <div v-else-if="data?.type === 'text'">
                    <div class="flex center vcenter" :style="{ 'width': '100%' }">
                        <span :style="{ 'width': '100% !important' }" class="description">
                            {{ data?.description }}
                        </span>
                    </div>
                    <Accordion :title="data?.extras.title" :description="data?.extras.entity.description"
                        :default="data?.extras.entity.default"></Accordion>
                    <div class="full flex wrap center vcenter">
                        <Button :meta="data?.button" :active="active" @onclick="onclick"></Button>
                    </div>
                </div>
                <div v-else-if="data?.type === 'validate'" class="overview flex wrap">
                    <template v-for="(item, index) in data?.metas" :key="index">
                        <div class="flex wrap center">
                            <p>{{ item.name }}</p>
                            <span>{{ data?.models?.[item.key] || 'بدون مقدار' }}</span>
                        </div>
                    </template>
                    <div class="actions full flex wrap center vcenter">
                        <Option :color="'red'" :icon="'fe-edit'" :name="'ویرایش'" :state="'open'"
                            @onclick="onresult('edit')">
                        </Option>
                        <Option :color="'green'" :icon="'fe-check'" :name="'تائید'" :state="'open'"
                            @onclick="onresult(true)">
                        </Option>
                    </div>
                </div>
                <div v-else-if="data?.type === 'attention'" class="attention flex wrap">
                    <div class="symbol flex wrap center vcenter">
                        <img v-lazy="'/images/sejam.webp'" alt="آتیاکراد - سجام" loading="lazy" />
                    </div>
                    <p>{{ data?.text }}</p>
                    <div class="actions full flex wrap center vcenter">
                        <template v-for="(item, index) in data?.buttons" :key="index">
                            <Option :color="item.color" :icon="item.icon" :name="item.name" :state="'open'"
                                @onclick="item.click">
                            </Option>
                        </template>
                    </div>
                </div>
                <div v-else-if="data?.type === 'investment'" class="investment flex wrap">
                    <div class="symbol flex wrap center vcenter">
                        <img v-lazy="'/images/invest.gif'" alt="آتیاکراد - سجام" loading="lazy" />
                    </div>
                    <p>{{ data?.text }}</p>
                    <div class="actions full flex wrap center vcenter">
                        <template v-for="(item, index) in data?.buttons" :key="index">
                            <Option :color="item.color" :icon="item.icon" :name="item.name" :state="'open'"
                                @onclick="item.click">
                            </Option>
                        </template>
                    </div>
                </div>
                <div v-else-if="data?.type === 'comment'" class="comment flex wrap center vcenter">
                    <MetaBox :meta="{
                        key: 'comment',
                        type: 'textarea',
                        name: 'کامنت کارشناس',
                        extras: 'R0:key=minimal,value=YES'
                    }" @onchange="(obj) => {
                        models[obj.key] = obj.value
                    }"></MetaBox>
                    <div class="actions full flex wrap center vcenter">
                        <Option :color="'red'" :icon="'fe-edit'" :name="'انصراف و ویرایش'" :state="'open'"
                            @onclick="onresult('edit')">
                        </Option>
                        <Option :color="'green'" :icon="'fe-check'" :name="'ثبت کامنت'" :state="'open'" @onclick="() => {
                            if (!base.Util().validate(models['comment'])) {
                                base.Notification().error({
                                    code: 1000,
                                    text: 'کامنت کارشناس'
                                })
                                return
                            }

                            $emit('onsubmit', {
                                parent_id: $route.params.id,
                                message: models['comment']
                            })
                        }">
                        </Option>
                    </div>
                </div>
                <div v-else-if="data?.type === 'quick'" class="quick flex wrap center">
                    <Tabs :meta="{
                        type: 'category',
                        extras: `R0:key=sms,value=پیام کوتاه;
                        R1:key=reminder,value=یادآور;
                        R2:key=payment,value=لینک پرداخت`
                    }" :vm="models['category'] || 'sms'" @onchange="(obj) => models['category'] = obj.value"></Tabs>
                    <SMS v-if="models['category'] === 'sms'" :data="data" @onresult="onresult"></SMS>
                    <Reminder v-else-if="models['category'] === 'reminder'" :data="data" @onresult="onresult">
                    </Reminder>
                </div>
                <div v-else-if="data?.type === 'investments'" class="flex wrap center">
                    <Investments :data="data" @onresult="onresult"></Investments>
                </div>
                <Search v-else-if="data?.type === 'search'" :data="data" @onresult="(obj) => onresult()"></Search>
                <Parents v-else-if="data?.type === 'parents'" :data="data" @onresult="onresult">
                </Parents>
                <Finder v-else-if="data?.type === 'finder'" :data="data" @onresult="onresult"></Finder>
                <Verify v-else-if="data?.type === 'verify'" :data="data" @onresult="onresult"></Verify>
                <Export v-else-if="data?.type === 'export'" :data="data" @onloading="onloading"
                    @onresult="(obj) => onresult()">
                </Export>
                <Document v-else-if="data?.type === 'document'" :data="data" @onloading="onloading"
                    @onresult="(obj) => onresult()">
                </Document>
                <Request v-else-if="data?.type === 'request'" :data="data" @onloading="onloading"
                    @onresult="(obj) => onresult()">
                </Request>
                <UserAction v-else-if="data?.type === 'useraction'" :data="data" @onloading="onloading"
                    @onresult="onresult">
                </UserAction>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { defineAsyncComponent } from 'vue'

import Search from './Dialogs/Search.vue'
import Parents from './Dialogs/Parents.vue'
import Verify from './Dialogs/Verify.vue'
import Export from './Dialogs/Export.vue'
import Document from './Dialogs/Document.vue'
import Request from './Dialogs/Request.vue'
import UserAction from './Dialogs/UserAction.vue'
import Button from '../components/Form/Button.vue'
import Accordion from './Form/Accordion.vue'
import Option from './Form/Option.vue'
import SMS from './Dialogs/SMS.vue'
import Reminder from './Dialogs/Reminder.vue'
import Tabs from './Form/Inputs/Tabs.vue'
import Finder from './Dialogs/Finder.vue'
import Investments from './Dialogs/Investments.vue'

export default {
    name: 'Dialog',
    props: ['data', 'show'],
    inject: ['base'],
    components: {
        Form: defineAsyncComponent(() => import('./Form.vue')),
        MetaBox: defineAsyncComponent(() => import('./Form/Inputs/MetaBox.vue')),
        Search, Parents, Verify, Export, Document, Request, UserAction, Accordion, Button, Option, SMS, Reminder, Tabs, Finder, Investments
    },
    data() {
        return {
            active: false,
            models: {}
        }
    },
    methods: {
        onclick(obj) {
            this.active = true
            this.$emit('onclick', this.data?.extras.entity.id, () => this.active = false)
        },
        onresult(obj) {
            this.$emit('onresult', obj)
        },
        onloading(status) {
            this.$emit('onloading', status)
        }
    }
}
</script>

<style scoped src="../assets/css/components/dialog.css"></style>
<style scoped src="../assets/css/components/dialog_dark.css"></style>